type TrackPurchaseParams = {
  fbc: string;
  fbp: string;
  userEmail: string;
  userId?: string;
  price: number;
  service: string;
  eventId?: string;
};

type TrackAddToCartParams = {
  fbc: string;
  fbp: string;
  userEmail: string;
  userId?: string;
  price: number;
  service: string;
  eventId?: string;
};

const sha256 = async (text: string): Promise<string> => {
  const enc = new TextEncoder().encode(text.trim().toLowerCase());
  const hashBuffer = await crypto.subtle.digest('SHA-256', enc);
  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
};

export const trackSchedule = async (params: TrackPurchaseParams) => {
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const eventSourceUrl = typeof window !== 'undefined' ? window.location.href : '';

  const hashedEmail = await sha256(params.userEmail);
  const hashedExternalId = params.userId ? await sha256(params.userId) : undefined;

  const payload = {
    event_name: 'Schedule',
    event_time: Math.floor(Date.now() / 1000),
    action_source: 'website',
    event_source_url: eventSourceUrl,
    event_id: params.eventId,
    user_data: {
      em: hashedEmail,
      external_id: hashedExternalId,
      fbp: params.fbp,
      fbc: params.fbc,
      client_user_agent: userAgent,
    },
    custom_data: {
      value: params.price,
      currency: 'EUR',
      content_ids: ['prenotazione'],
      content_type: 'product',
      content_name: 'prenotazione',
    },
  };

  const res = await fetch('/api/fb/yes', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Meta send failed ${res.status}: ${text}`);
  }

  return res.json();
};

export const trackAddToCart = async (params: TrackAddToCartParams) => {
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const eventSourceUrl = typeof window !== 'undefined' ? window.location.href : '';

  try {
    const hashedEmail = await sha256(params.userEmail);
    const hashedExternalId = params.userId ? await sha256(params.userId) : undefined;

    const payload = {
      event_name: 'AddToCart',
      event_time: Math.floor(Date.now() / 1000),
      action_source: 'website',
      event_source_url: eventSourceUrl,
      event_id: params.eventId,
      user_data: {
        em: hashedEmail,
        external_id: hashedExternalId,
        fbp: params.fbp,
        fbc: params.fbc,
        client_user_agent: userAgent,
      },
      custom_data: {
        value: params.price,
        currency: 'EUR',
        content_ids: ['prenotazione'],
        content_type: 'product',
        content_name: 'prenotazione',
      },
    };

    const res = await fetch('/api/fb/yes', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(`Meta send failed ${res.status}: ${text}`);
    }

    return res.json();
  } catch (error) {
    console.error(error);
  }
};
